export const editActions = <const>{
	ZAKAZNIK_CHANGE: 'zakaznikChange',
	VOZIDLO_CHANGE: 'vozidloChange',
	PREDMET_CHANGE: 'predmetChange',
	CREATE_FROM_PLANOVANA_PUJCKA: 'createFromPlanovanaPujcka',
	ROZSIRENI_PROTOKOLU_CHECK: 'rozsireniProtokoluCheck',
	ROZSIRENI_PROTOKOLU: 'rozsireniProtokolu',
	UPDATE_ZAPUJCKU: 'updateZapujcku',
	CREATE_ZAKAZKA: 'createZakazka',
};

export const listMutations = <const>{
	ZAPUJCKA_ZAKAZNIK_FILTER_SELECT_MAPPER: 'ZAPUJCKA_ZAKAZNIK_FILTER_SELECT_MAPPER',
	ZAPUJCKA_VOZIDLO_FILTER_SELECT_MAPPER: 'ZAPUJCKA_VOZIDLO_FILTER_SELECT_MAPPER',
	ZAPUJCKA_ZAKAZKA_FILTER_SELECT_MAPPER: 'ZAPUJCKA_ZAKAZKA_FILTER_SELECT_MAPPER',
	ZAPUJCKA_VSTUP_PRAC_FILTER_SELECT_MAPPER: 'ZAPUJCKA_VSTUP_PRAC_FILTER_SELECT_MAPPER',
};

export const editMutations = <const>{
	VOZIDLO_CHANGED: 'VOZIDLO_CHANGED',
	ZAKAZNIK_CHANGED: 'ZAKAZNIK_CHANGED',
	PREDMET_CHANGED: 'PREDMET_CHANGED',
	VOZIDLO_CHANGED_ADDITIONAL: 'VOZIDLO_CHANGED_ADDITIONAL',
	ZAPUJCKA_PREDMET_PUJCOVNA_SELECT_MAPPER: 'ZAPUJCKA_PREDMET_PUJCOVNA_SELECT_MAPPER',
	ZAPUJCKA_PARTNER_SELECT_MAPPER: 'ZAPUJCKA_PARTNER_SELECT_MAPPER',
	ZAPUJCKA_VOZIDLO_PUJCOVNA_SELECT_MAPPER: 'ZAPUJCKA_VOZIDLO_PUJCOVNA_SELECT_MAPPER',
	ZAPUJCKA_ZAKAZKA_SELECT_MAPPER: 'ZAPUJCKA_ZAKAZKA_SELECT_MAPPER',
	ZAPUJCKA_PRACOVNIK_SELECT_MAPPER: 'ZAPUJCKA_PRACOVNIK_SELECT_MAPPER',
	ZAPUJCKA_NAKLADOVE_STREDISKO_SELECT_MAPPER: 'ZAPUJCKA_NAKLADOVE_STREDISKO_SELECT_MAPPER',
	ROZSIRENI_PROTOKOLU_CHECK_MUTATION: 'ROZSIRENI_PROTOKOLU_CHECK_MUTATION',
	ROZSIRENI_PROTOKOLU_MUTATION: 'ROZSIRENI_PROTOKOLU_MUTATION',
	ZAPUJCKA_CHECK_RESULT_RESET: 'zapujckaCheckResultReset',
	ZAPUJCKA_ROZSIR_PROTOKOL: 'zapujckaRozsirProtokol',
	SAVED_BEFORE_NAJEMNI_SMLOUVA_PRINT: 'savedBeforePrint',
};
